document.addEventListener('DOMContentLoaded', function () {
  $('.home-banner-section').on('initial', function (e) {
    var $homeBannerSection = $(this);
    setTimeout(function () {
      $('.square-container', $homeBannerSection).addClass('fade-in');
    }, 500);
  }).trigger('initial');
  $('.home-whatson-section').on('initial', function (e) {
    var $navba = $('.navbar'),
      $homeWhatsonSection = $(this);
    $(window).on('scroll', function () {
      var $whatsOnBlocks = $('.whatson-block', $homeWhatsonSection);
      if ($whatsOnBlocks.length <= 1) return $homeWhatsonSection.removeClass('sticky-effect sticky-fadeout-effect');
      var navbarHeight = $navba.outerHeight(),
        navbarBottom = $navba.offset().top + navbarHeight,
        sectionTop = $homeWhatsonSection.offset().top + 32,
        sectionHeight = $homeWhatsonSection.outerHeight(),
        bottomBuffer = window.innerHeight * 0.9;
      // if the screen is entering $homeWhatsonSection section, add sticky-effect class
      $homeWhatsonSection[navbarBottom > sectionTop ? 'addClass' : 'removeClass']('sticky-effect');
      // if the $homeWhatsonSection is leaving the screen, add sticky-fadeout-effect class
      $homeWhatsonSection[navbarBottom > sectionTop + sectionHeight - bottomBuffer ? 'addClass' : 'removeClass']('sticky-fadeout-effect');
      // find the first .whatson-block visible in the screen
      var $visibleBlock = $whatsOnBlocks.filter(function () {
        var buffer = window.innerHeight * 0.1;
        return $(this).offset().top + $(this).outerHeight() > navbarBottom + navbarHeight + buffer;
      }).first();
      $('.image-background-container .image', $homeWhatsonSection).removeClass('active').eq($visibleBlock.index()).addClass('active');
    });
  }).on('mouseenter', '.whatson-block .image', function (e) {
    e.preventDefault();
    $(this).parents('.home-whatson-section').addClass('hover-effect');
  }).on('mouseenter', '.close-layer', function (e) {
    e.preventDefault();
    $(this).parents('.home-whatson-section').removeClass('hover-effect');
  }).on('click', '[data-toggle-date-range]', function (e) {
    e.preventDefault();
    var $this = $(this),
      $toggleRangeBtns = $this.siblings('[data-toggle-date-range]'),
      $section = $(this).parents('.home-whatson-section'),
      $imageBackgrounds = $('.image-backgrounds', $section),
      $whatsonHolder = $('.whatson-holder', $section),
      dateRange = $this.attr('data-toggle-date-range'),
      dataSource = JSON.parse(dateRange === 'today' ? $section.attr('data-source-today') : $section.attr('data-source-next-week')),
      emptyString = $section.attr('data-empty');
    // toggle active class
    $toggleRangeBtns.removeClass('active');
    $this.addClass('active');
    $imageBackgrounds.empty();
    $whatsonHolder.empty();
    // handle if empty
    if (dataSource.length === 0) {
      return $whatsonHolder.append($('<p />').addClass('empty').text(emptyString));
    }
    dataSource.forEach(function (data, index) {
      // add images in $imageBackgrounds
      var $img = $('<img />').attr('src', data.cover),
        $imgContainer = $('<div />').addClass('image').append($img);
      if (index === 0) $imgContainer.addClass('active');
      $imageBackgrounds.append($imgContainer);
      // add whatsonBlock in $whatsonHolder
      var $whatsonBlock = $('<a />').addClass('whatson-block').attr('href', data.url).attr('data-name', data.title),
        $dataContainer = $('<div />').addClass('data-container'),
        $titleContainer = $('<div />').addClass('title-container'),
        $infoContainer = $('<div />').addClass('info-container');
      $whatsonBlock.append($('<div />').addClass('image').append($('<img />').attr('src', data.cover)));
      $whatsonBlock.append($dataContainer.append($titleContainer).append($infoContainer));
      $titleContainer.append($('<label />').html(data.date)).append($('<h4 />').html(data.title));
      $infoContainer.append($('<p />').html(data.detail));
      $whatsonHolder.append($whatsonBlock);
    });
  }).trigger('initial');
  $('.home-dx-section').on('click', '[data-toggle-map-spot]', function (e) {
    e.preventDefault();
    var $this = $(this),
      $section = $this.parents('.home-dx-section'),
      $toggleMapSpot = $this.siblings('[data-toggle-map-spot]'),
      $layers = $('.spots-relative-container', $section),
      showLayer = $this.attr('data-toggle-map-spot');
    // toggle active class
    $toggleMapSpot.removeClass('active');
    $this.addClass('active');
    // toggle show class
    $layers.removeClass('active');
    $layers.filter(`[data-type="${showLayer}"]`).addClass('active');
  }).on('click', '.hub-map', function (e) {
    e.preventDefault();
    var $hubMap = $(this),
      $dialog = $('.dialog', $hubMap);
    $dialog.removeClass('show');
  }).on('click', '.spot[data-content]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $spot = $(this),
      $hubMap = $spot.parents('.hub-map'),
      $dialog = $('.dialog', $hubMap),
      $dialogContainer = $('.dialog-container', $dialog),
      $dialogBtn = $('#hub-dialog-view-all', $dialog);

    // Get $spot relative top left in $hubMap
    var spotOffset = $spot.offset(),
      hubMapOffset = $hubMap.offset(),
      spotTop = spotOffset.top - hubMapOffset.top,
      spotLeft = spotOffset.left - hubMapOffset.left,
      spotWidth = $spot.outerWidth();
    console.log({
      spotTop,
      spotLeft,
      spotWidth
    });

    // Add $spot attr to $dialog
    var title = $spot.attr('data-title'),
      content = $spot.attr('data-content'),
      href = $spot.attr('data-href'),
      urlType = $spot.attr('data-url-type');
    $dialogContainer.empty();
    if (title) $dialogContainer.append('<h3>' + $spot.attr('data-title') + '</h3>');
    if (content) $dialogContainer.append($spot.attr('data-content'));
    if (href) {
      $dialogBtn.attr('href', href).attr('target', urlType === 'external' ? '_blank' : '_self').removeClass('d-none');
    } else {
      $dialogBtn.addClass('d-none');
    }

    // Calculate $dialog width, set $dialog at the left of the $spot
    var dialogWidth = $dialog.outerWidth();
    $dialog.css({
      top: spotTop,
      left: Math.max(0, spotLeft - dialogWidth - spotWidth / 2)
    });
    // Show $dialog
    $dialog.addClass('show');
  }).on('click', '#hub-dialog-view-all', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $a = $(this);
    if ($a.attr('target') === '_blank') {
      return window.open($a.attr('href'), '_blank');
    }
    window.location.href = $a.attr('href');
    return;
  });
  $('#whatson-filter-form, #programme-filter-form, #dx-happenings-filter-form, #press-release-filter-form, #news-coverage-filter-form').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this),
      actionUrl = $form.attr('action') ?? `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

    // Submit form using ajax
    $.ajax({
      url: actionUrl,
      type: $form.attr('method') ?? 'GET',
      data: $form.serialize(),
      dataType: 'text',
      beforeSend: function () {
        // add form>date to query string use history api
        var url = new URL(actionUrl);
        $form.serializeArray().map(field => {
          if (String(field.value).length === 0) return;
          if (field.name === 'tags') return url.searchParams.append('tags', field.value);
          return url.searchParams.set(field.name, field.value);
        });
        history.pushState({}, '', url);
      },
      success: function (html) {
        var reflectContainer = null;
        switch ($form.attr('id')) {
          case 'whatson-filter-form':
            reflectContainer = '#whatson-container';
            break;
          case 'programme-filter-form':
            reflectContainer = '#programme-container';
            break;
          case 'dx-happenings-filter-form':
            reflectContainer = '#dx-happenings-container';
            break;
          case 'press-release-filter-form':
            reflectContainer = '#press-release-container';
            break;
          case 'news-coverage-filter-form':
            reflectContainer = '#news-coverage-container';
            break;
        }
        var $data = $(html);
        $(reflectContainer).html($data.find(reflectContainer).html());
        $('[data-append-container="' + reflectContainer + '"]').prop('currentPage', 1);
        $('html, body').scrollTop(0);
      }
    });
  });
  $('.programme-detail-section').on('index-changed', '.programme-image-container', function (e, index) {
    var $imgContainer = $(this),
      $section = $imgContainer.parents('.programme-detail-section'),
      $enlargeImg = $('.enlarge-cover img', $section);
    $enlargeImg.attr('src', $('img', $imgContainer).eq(index).attr('src'));
  });
  $('.timeline-section').on('initial', function () {
    var $section = $(this),
      $navbar = $('.navbar'),
      $horizontalYearSelector = $('.horizontal-year-selector'),
      $years = $('.years .year[href]', $horizontalYearSelector),
      $timelineItems = $('.timeline-item'),
      $timelineEvents = $('.timeline-event', $timelineItems),
      $itemlineSectionLeaveAnchor = $('#timeline-section-leaving', $section);
    $(window).on('scroll', function () {
      var scrollTop = $(window).scrollTop(),
        windowHeight = window.innerHeight,
        navHeight = $navbar.outerHeight();

      // when $section reach the bottom of the nav.navbar, add .docking class, else remove .docking class
      $section[scrollTop + navHeight >= $section.offset().top + 32 ? 'addClass' : 'removeClass']('desktop-docking');
      // when $itemlineSectionLeaveAnchor fade in from the bottom, add .docking-leave class, else remove .docking-leave class
      $section[scrollTop + windowHeight >= $itemlineSectionLeaveAnchor.offset().top ? 'addClass' : 'removeClass']('desktop-docking-leave');

      // when $section bottom is on screen, add .docking-leave class, else remove .docking-leave class
      // $section[scrollTop >= $section.height() - $section.offset().top - 64 ? 'addClass' : 'removeClass']('desktop-docking-leave');

      // when .timeline-item reach the bottom of the nav.navbar, add class .active, else remove class .active,
      var itemMobileBuffer = window.innerHeight * 0.25;
      $timelineItems.each(function () {
        var $timelineItem = $(this),
          timelineItemTop = $timelineItem.offset().top;
        $timelineItem[scrollTop + navHeight + itemMobileBuffer >= timelineItemTop ? 'addClass' : 'removeClass']('active');
        $years.filter(`[href="#${$timelineItem.attr('id')}"]`)[scrollTop + navHeight + itemMobileBuffer >= timelineItemTop ? 'addClass' : 'removeClass']('active');
      });

      // when .timeline-event reach the bottom of the nav.navbar, add class .active, else remove class .active,
      var eventMobileBuffer = window.innerHeight * 0.25;
      $timelineEvents.each(function () {
        var $timelineEvent = $(this),
          timelineEventTop = $timelineEvent.offset().top;
        if (scrollTop + navHeight + eventMobileBuffer >= timelineEventTop) {
          $timelineEvent.addClass('active');
        } else {
          $timelineEvent.removeClass('active');
        }
      });

      // when no active, the first event and item will become active
      if ($timelineEvents.filter('.active').length === 0) {
        $timelineItems.eq(0).addClass('active');
        $timelineEvents.eq(0).addClass('active');
        $years.eq(0).addClass('active');
      }
      // render image preview from the last active event
      $timelineEvents.filter('.active').eq(-1).trigger('render-image-preview');
    });
  }).on('render-image-preview', '.timeline-event', function (e) {
    e.preventDefault();
    var $timelineEvent = $(this),
      $figure = $('figure', $timelineEvent),
      $verticalTimeline = $figure.parents('.vertical-timeline'),
      $figureHolder = $('.image-preview-container .figure-holder', $verticalTimeline);
    if ($figureHolder.attr('data-event') === $timelineEvent.attr('id')) return;
    $figureHolder.attr('data-event', $timelineEvent.attr('id'));
    $figureHolder.removeClass('show').find('figure').remove();
    $figure.clone().appendTo($figureHolder);
    setTimeout(function () {
      $figureHolder.addClass('show');
    }, 10);
  }).on('click', 'button[data-event=show-figures]', function (e) {
    e.preventDefault();
    var $figureHolder = $(this).parents('.figure-holder'),
      figureData = [];
    // convert figure in figure-holder to JSON data
    $('figure', $figureHolder).each(function () {
      var $figure = $(this),
        figure = {
          src: $('img', $figure).attr('src'),
          alt: $('figcaption', $figure).text()
        };
      figureData.push(figure);
    });
    // open modal with figureData
    $('#image-player-modal').trigger('render', [figureData]);
  }).on('click', '.horizontal-year-selector a.year[href]', function (e) {
    e.preventDefault();
    // scroll to target
    var $target = $($(this).attr('href'));
    if (!$target.length) return;
    var offset = $target.offset().top;
    window.scrollTo({
      top: offset - $('.navbar').outerHeight() - $('.horizontal-year-selector').outerHeight() + 1,
      behavior: 'smooth'
    });
  }).trigger('initial');
});